export default __webpack_public_path__ + "static/media/handshake.2dcf7703.png";